import { render, staticRenderFns } from "./AuthoritySelect.vue?vue&type=template&id=c560d24a"
import script from "./AuthoritySelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthoritySelect.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports